import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const createDraftOrders = createAction(actionTypes.CREATE_DRAFT_ORDERS);
export const createDraftOrdersSuccess = createAction(
  actionTypes.CREATE_DRAFT_ORDERS_SUCCESS,
);
export const createDraftOrdersFailure = createAction(
  actionTypes.CREATE_DRAFT_ORDERS_FAILURE,
);

export const createAutoTickets = createAction(actionTypes.CREATE_AUTO_TICKETS);
export const createAutoTicketsSuccess = createAction(
  actionTypes.CREATE_AUTO_TICKETS_SUCCESS,
);
export const createAutoTicketsFailure = createAction(
  actionTypes.CREATE_AUTO_TICKETS_FAILURE,
);

export const createAutoOrders = createAction(actionTypes.CREATE_AUTO_ORDERS);
export const createAutoOrdersSuccess = createAction(
  actionTypes.CREATE_AUTO_ORDERS_SUCCESS,
);
export const createAutoOrdersFailure = createAction(
  actionTypes.CREATE_AUTO_ORDERS_FAILURE,
);

export const autoPlanningAction = createAction(actionTypes.AUTO_PLANNING_ACTION);
export const autoPlanningActionSuccess = createAction(
  actionTypes.AUTO_PLANNING_ACTION_SUCCESS,
);
export const autoPlanningActionFailure = createAction(
  actionTypes.AUTO_PLANNING_ACTION_FAILURE,
);

export const deleteOrders = createAction(actionTypes.DELETE_ORDERS);
export const deleteOrdersSuccess = createAction(
  actionTypes.DELETE_ORDERS_SUCCESS,
);
export const deleteOrdersFailure = createAction(
  actionTypes.DELETE_ORDERS_FAILURE,
);

export const createSingleOrderFailure = createAction(
  actionTypes.CREATE_SINGLE_ORDER_FAILURE,
);

export const setSelectedRowAction = createAction(
  actionTypes.SET_SELECTED_ROW_ACTION,
);

export const publishToSapQuickAction = createAction(actionTypes.PUBLISH_TO_SAP_QUICK_ACTION);
export const publishToSapQuickActionSuccess = createAction(
  actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_SUCCESS,
);
export const publishToSapQuickActionFailure = createAction(
  actionTypes.PUBLISH_TO_SAP_QUICK_ACTION_FAILURE,
);

export const resetDeleteSuccess = createAction(
  actionTypes.RESET_DELETE_SUCCESS,
);

